import recentStateScoreIcon from '../../images/circle_icons/recent_state_score.svg';

export default function ReadingRecentTable({ item }) {
  return (
    <div className='flex w-full flex-row space-x-8 text-brandText'>
      <div className='flex w-full flex-col overflow-x-auto overflow-y-hidden rounded-lg border-2 border-x-slate-100 border-t-slate-50 border-b-slate-100 bg-white pt-5 pb-8 shadow-md'>
        <div className='flex flex-row items-center'>
          <div>
            <div className='ml-3 flex'>
              <img
                className='h-12 w-12 sm:h-14 sm:w-14'
                src={recentStateScoreIcon}
                alt='Grades'
              />
            </div>
          </div>
          <div>
            <h2 className='ml-2 text-2xl font-medium sm:text-3xl'>Recent</h2>
            <p className='ml-2 py-1 text-sm'>Score</p>
          </div>
          <div>
            <p className='ml-5 text-6xl font-bold text-brandPrimaryLight'>
              {item?.scale_score ? item?.scale_score : ''}
            </p>
          </div>
        </div>
        <div className='mt-3 w-full table-auto border-collapse bg-gradient-to-r from-slate-100 text-xs'>
          <p className='ml-10 text-base font-medium md:text-2xl xl:text-xl'>
            {item ? 'Grade' : ''}{' '}
            {item?.grade_level_iar ? item?.grade_level_iar : ''}
            {item ? ',' : ''}{' '}
            {item?.test_year?.end_year ? item?.test_year?.end_year : ''}{' '}
            {item ? 'Level' : ''}{' '}
            {item?.performance_level ? item?.performance_level : ''}&nbsp;
          </p>
        </div>
        {item ? (
          <div className='mx-12 mt-7 flex flex-col text-sm sm:text-base'>
            <h2 className='text-base font-medium sm:text-lg'>Subscores</h2>
            <div className='mt-1 flex flex-row justify-between'>
              <p>Reading Scale Score</p>
              <p>
                {item?.reading_scale_score ? item?.reading_scale_score : ''}
              </p>
            </div>
            <div className='mt-1 flex flex-row justify-between'>
              <p>Literary Text</p>
              <p>
                {item?.reading_subclaim_literacy_text
                  ? item?.reading_subclaim_literacy_text
                  : ''}
              </p>
            </div>
            <div className='mt-1 flex flex-row justify-between'>
              <p>Informational Text</p>
              <p>
                {item?.reading_subclaim_informational_text
                  ? item?.reading_subclaim_informational_text
                  : ''}
              </p>
            </div>
            <div className='mt-1 flex flex-row justify-between'>
              <p>Vocabulary</p>
              <p>
                {item?.reading_subclaim_vocabulary
                  ? item?.reading_subclaim_vocabulary
                  : ''}
              </p>
            </div>
            <div className='mt-1 flex flex-row justify-between'>
              <p>Written Expression</p>
              <p>
                {item?.writing_subclaim_writing_expression
                  ? item?.writing_subclaim_writing_expression
                  : ''}
              </p>
            </div>
            <div className='mt-1 flex flex-row justify-between'>
              <p>Knowledge & Use of Language</p>
              <p>
                {item?.writing_subclaim_knowledge_and_use_of_language
                  ? item?.writing_subclaim_knowledge_and_use_of_language
                  : ''}
              </p>
            </div>
          </div>
        ) : (
          <div className='mx-10 mt-7 flex flex-col'>
            <h2 className='text-lg font-medium'>No Records</h2>
          </div>
        )}
      </div>
    </div>
  );
}
